const OLD_SETTINGS_SHUTOFF_DATE = new Date(2026, 9, 23);

export function formatOldSettingsShutoffDate(): string {
  return OLD_SETTINGS_SHUTOFF_DATE.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
